<div *ngIf="isLoading; else content" class="wrapper">
  <div class="loader" [style]="{ background: bgColor }">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
